<script lang="ts" setup>
  import { dropdownPanelScrollClass } from './DropdownPanelScroll.css';
</script>

<template>
  <div :class="dropdownPanelScrollClass" data-test-id="dropdown-panel-scroll">
    <slot />
  </div>
</template>
